$(document).ready(function() {

  // body fixed class

    $(window).on("scroll touchstart touchmove", function(e) {
      var scroll = $(window).scrollTop();
      if (scroll > 0) {
          $('#shopify-section-header').addClass('fixed');
          $('body').addClass('fixed_header');
      } else {
          $('#shopify-section-header').removeClass('fixed');
          $('body').removeClass('fixed_header');
      }
  });
  
  // body fixed class

  $(document).on('click','.overlay',function(){
    $('.header-icons li.searchlist').removeClass('active');
    $('.snippet-collection-filter').removeClass('active');
    $('.main-service').removeClass('active');
    $('body').removeClass('active_overlay top_40 z-index-100');
    $('.sticky-header #shopify-section-header').css('z-index','99');
    $('.snippet-search-bar input#Search').val('');
     $('.main-search-result').removeClass('active');
  });

  // search bar

  $(document).on('click','.header-icons .search a',function(e){
    $('.header-icons li.searchlist').addClass('active');
     $('.main-search-result').addClass('active');



    new Swiper('.search_recommended_inr', {
        slidesPerView: 1.7,
        spaceBetween: 1,
        mousewheel: {
          releaseOnEdges: true,
        },
        breakpoints: {
              1920: {
                  slidesPerView: 4,
                  spaceBetween: 10,
                  loop: false,
              },
              1028: {
                  slidesPerView: 4,
                  spaceBetween: 10,
                  loop: false,
              },
              480: {
                  slidesPerView: 2,
                  spaceBetween: 1,
                  loop: true,
              }
          },
      scrollbar: {
        el: ".swiper-scrollbar",
      }
    });


    $('body').addClass('active_overlay top_40');
    setTimeout(function(){
      $('.snippet-search-bar input#Search')[0].focus();
    },200);
    $('body').addClass('fixed_header open-search');
    $('#shopify-section-header').addClass('fixed');
  });

  // custom serach btn
 $(document).on('click','.active-search',function(e){
   $('.menu-close button').addClass('close-menu');
    $('.header-icons li.searchlist').removeClass('active');
     $('.main-search-result').removeClass('active');
    $('.menu-close button').removeClass('active-search');
    document.querySelector('body').classList.add('open-menu');
 });
  
  $(document).on('click','.custom-search-btn',function(e){
    $('.header-icons li.searchlist').addClass('active');
     $('.main-search-result').addClass('active');
    // $('.menu-close button').removeClass('close-menu');
    // $('.menu-close button').addClass('active-search');
    
    new Swiper('.search_recommended_inr', {
        loop: true,
        slidesPerView: 1.7,
        spaceBetween: 1,
        mousewheel: {
          releaseOnEdges: true,
        },
        breakpoints: {
              1920: {
                  slidesPerView: 4,
                  spaceBetween: 10,
                  loop: false,
              },
              1028: {
                  slidesPerView: 4,
                  spaceBetween: 10,
                  loop: false,
              },
              480: {
                  slidesPerView: 2,
                  spaceBetween: 1,
                  loop: true,
              }
          },
      scrollbar: {
        el: ".swiper-scrollbar",
      }
    });


    $('body').addClass('active_overlay top_40');
    setTimeout(function(){
      $('.snippet-search-bar input#Search')[0].focus();
    },200);
    $('body').addClass('fixed_header open-search');
    $('#shopify-section-header').addClass('fixed');
  });
  
  
  $('.search_close, .close-menu').click(function(){
    // $('.menu-close button').removeClass('active-search').addClass('close-menu');
    $('.header-icons li.searchlist').removeClass('active');
    $('.snippet-search-bar input#Search').val('');
    $('body').removeClass('active_overlay top_40');
    $('body').removeClass('fixed_header open-search');
    $('#shopify-section-header').removeClass('fixed');
     $('.main-search-result').removeClass('active');
  })
  
  // search bar

  // home page collection list slider in mobile

  
  
  // home page collection list slider in mobile



  // collection filter open and colse

  $(document).on('click','.collection-filter-btn',function(){
    $('.snippet-collection-filter').addClass('active');
    $('body').addClass('active_overlay z-index-100');
    $('.sticky-header #shopify-section-header').css('z-index','98')
  })
  $(document).on('click','.filter-top-inner .filter-close',function(){
    $('.snippet-collection-filter').removeClass('active');
    $('body').removeClass('active_overlay z-index-100');
    $('.sticky-header #shopify-section-header').css('z-index','99')
  })
  
  // collection filter open and colse

  // collection mobile grid

  $(document).on('click','.collection-mobile-bottom .grid-icon',function(){
    $('.inner-icon').toggleClass('active');
    $('.product-link').toggleClass('unclick');
    $('.collection-grid').toggleClass('grid-1');
    var $carousel = $('.product-images').flickity();
    $( ".product-images" ).each(function( event ) {
      var childrenSlide = $(this).children().length;
      var $elem = this;
      if ($(".collection-grid").hasClass("grid-1")) {
        if (childrenSlide == 2) {
            var flkty = new Flickity( $elem, {
            cellAlign: 'left',
            contain: true,
            draggable: false
          });
        }
      }else{
       $(this).flickity('destroy');
      }
      
    });
    
  })

  if($(window).width() <= 767){
   $(".unclick").click(function(event) {
        event.preventDefault();
   }); 
  }
  
  // collection mobile grid

  

  // mobile add to cart slide up

  if( $('.trigger-btn').length > 0){
    $(document).on('click','.mobile-trigger-btn .trigger-btn',function(e){
      $('.one-tab').addClass('active');
      $('.one-tab-bg').addClass('active');
      $('#shopify-section-announcement-bar , #shopify-section-header').addClass('z-index-0');
      $('body').addClass('overflow');
    })

    $(document).mouseup(function (e) {
    var clickplace = $(".one-tab.active");
        if (!clickplace.is(e.target) && clickplace.has(e.target).length == 0) {
          $('.one-tab').removeClass('active');
          $('.one-tab-bg').removeClass('active');
          $('.section-product').removeClass('z-index');
          $('#shopify-section-announcement-bar , #shopify-section-header').removeClass('z-index-0');
          $('body').removeClass('overflow');
        }
    });
    
  }
  
  // mobile add to cart slide up

  // shop the look add to cart

  
  if( $('.add-to-cart .not-var').length > 0){
    $(document).on('click','.add-to-cart .not-var',function(){
      var line = $(this).data('id');
      addItem(line);
    });

    function addItem(line) {
    let data = {
     'items': [{
      'id': line,
      'quantity': 1
      }]
    };

      fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
      })
      .then((response) => response.json())
      .then((data) => {
          load_cart();
          setTimeout(() => {
            document.querySelector('body').classList.add('open-drawer');
          }, "500");
      })
      .catch((error) => {
          console.error('Error:', error);
      });
  }
  }
  
  // shop the look add to cart

$(document).on('click', '.now-add-to-cart .var', function(event) {
  event.preventDefault();
  $('.choose-cart .product-addcart').trigger('click');
});




  // announcement bar service 

// For desktop: Use mouseenter to add classes
$(document).on('mouseenter', '.service-btn', function(e) {
  if (!('ontouchstart' in window)) { // Check if it's not a touch device
      $('.main-service').addClass('active');
      $('#shopify-section-announcement-bar').addClass('active');
      $('body').addClass('active_overlay');
  }
});

$(document).on('mouseleave', '.main-service', function(e) {
  if (!('ontouchstart' in window)) { // Check if it's not a touch device
      $('.main-service').removeClass('active');
      $('#shopify-section-announcement-bar').removeClass('active');
      $('body').removeClass('active_overlay');
  }
});

  $(document).on('click','.service-top .service-close',function(e){
    $('.main-service').removeClass('active');
    $('#shopify-section-announcement-bar').removeClass('active');
    $('body').removeClass('active_overlay')
  })
  
  // announcement bar service 

  // cart page tab

  if( $('.bottom-shiping-details').length > 0){
    $(document).on('click','.bottom-shiping-details .tab-title li',function(){
      $(this).addClass('active').siblings().removeClass('active');
      var id = $(this).attr('data-id');
      var cust_class = "."+id;
      $('.bottom-shiping-details .tab-decription li').hide();
      $(cust_class).slideDown()
    })
  }
  
  // cart page tab

  // announcement bar and header height get

  var ann = $('.section-announcement-bar').height();
  var header = $('#shopify-section-header').height();
  var total = (ann + header + 'px');
  $('body.top-100 main , body.top-100 #shopify-section-footer').css("top", total)

  // announcement bar and header height get


  // about page animation
   // media with text section

  
  // window.onscroll = function () {
  //   var sectionbgSelector = document.querySelector(".index_video_block");
  //   if (!sectionbgSelector) return false;
  //   var secpostion = sectionbgSelector.offsetTop + 300;
  //   var sectionHeight = sectionbgSelector.clientHeight;
  //   var win = window.innerHeight + window.scrollY;
  //   var endDistance = secpostion + sectionHeight;
  //   var scroll = sectionbgSelector.offsetTop + 100;
  //   var test = $('.index_video_block').offset().top - $(window).scrollTop();

  //   console.log(test,'------>')

  //   setTimeout(function () {
  //     if (win >= scroll) {
  //       $(".medtext_wraper").addClass("newclass");
  //       $(".medtext_wraper").removeClass("oldclass");
  //     }
  //     if (win >= endDistance) {
  //       $(".medtext_wraper").removeClass("newclass");
  //       $(".medtext_wraper").addClass("oldclass");
  //     }
  //     if (win <= scroll) {
  //       $(".medtext_wraper").removeClass("newclass");
  //     }
  //   }, 1000);





  //   // $(window).on('wheel', function(event){
  //   //   if (win >= scroll) {
  //   //     $(".medtext_wraper").addClass("up");
  //   //     $('body').removeClass('image-fixed')
  //   //   }
  //   //   if (win >= endDistance) {
  //   //     $(".medtext_wraper").removeClass("up");
  //   //   }
  //   // });

    
  //   // if (test < 0){
  //   //   $('body').removeClass('image-fixed')
  //   //   $(".medtext_wraper").removeClass("up");
  //   //   $(".medtext_wraper").addClass("main-up");
  //   // }

  //   // if ($("body").hasClass("image-fixed")) {
  //   //   $(window).on('wheel', function(event){
  //   //     $(".medtext_wraper").addClass("up");
  //   //   });
  //   // }


  // };



  // animation js

  jQuery(function($) {
    var doAnimations = function() {
        var offset = $(window).scrollTop() + $(window).height(),
            $animatables = $('.animatable');
        if ($animatables.length == 0) {
          $(window).off('scroll', doAnimations);
        }
        $animatables.each(function(i) {
           var $animatable = $(this);
            if (($animatable.offset().top + $animatable.height() - 20) < offset) {
              $animatable.removeClass('animatable').addClass('animated');
            }
        });
  	};
  	$(window).on('scroll', doAnimations);
      $(window).trigger('scroll');
  });
  
  // animation js


  $(document).on('click','.mobile-nav.second-mobile-nav li.service',function(){
    $('body').removeClass('open-menu');
    $('.main-service').addClass('active');
    $('#shopify-section-announcement-bar').addClass('active');
  });


   $("ul.list-menu li.mega-list").hover(function(){
    $('body').addClass("active_overlay");
  });

  $("ul.list-menu li.mega-list").hover(function(){
      $('body').addClass("active_overlay top_40");
    }, function(){
      $('body').removeClass("active_overlay top_40");
  });


  // footer height get

  var footer = $('.footer-bottom-inner').height();
  $('.footer-bottom').css("min-height", footer)
  
  // footer height get



  // $(window).bind('mousewheel', function(event) {
  //   if (event.originalEvent.wheelDelta >= 0) {
  //     $('body.collection').removeClass('scroll-down')
  //   }
  //   else {
  //     $('body.collection').addClass('scroll-down')
  //   }
  // });

    $(".variant-row-list .singal-var.test").slice(0, 5).show();
    $("#loadMore").on('click', function(e) {
      e.preventDefault();
      $(".variant-row-list .singal-var.test:hidden").slice(0, 50).slideDown();
        $("#loadLess").fadeIn('slow');
        $("#loadMore").hide();
    });
  
    $("#loadLess").on('click', function(e) {
      e.preventDefault();
      $('.variant-row-list .singal-var.test:not(:lt(5))').fadeOut();
      $("#loadMore").fadeIn('slow');
      $("#loadLess").hide();
  
      desiredHeight = $(window).height();
    });

     var gridTitle = $('.desc_left .pro_title.last').height() + 10;
      $('.snippet-promo-image .snippet-media-box').css('height',`calc(100% - ${gridTitle}px)`);


    // outside click close popup
      $(document).mouseup(function (e) {
      var clickplace = $(".inner-size-chart");
          if (!clickplace.is(e.target) && clickplace.has(e.target).length == 0) {
            $('.product-size-chart').removeClass('active');
            $('body').removeClass('overflow')
          }
      });
    // outside click close popup


      //   function ChangeUrl( url) {
      //       if (typeof (history.pushState) != "undefined") {
      //           var obj = { Url: url };
      //           history.pushState(obj, obj.Url);
      //       } else {
      //           alert("Browser does not support HTML5.");
      //       }
      //   }
  
      // $('.add-add-btn.new .save').click(function() {
      //    ChangeUrl('added');
      // })

        function account_add(){
        setTimeout(function(){
              var url = new window.URL(document.location); 
              url.searchParams.set("added", "add");
              location.href = url.toString();
        },100)
        }
        $(function(){
            $('.add-add-btn.new .save').click(account_add);
            if (window.location.href=="https://blush-jewels.com/account/addresses?added=add") {
              $('.add-account-success').addClass('active');
              setTimeout(() => {
                $('.add-account-success.active').removeClass('active');
              }, "5000")
            }
        })


  

    if( $('.section-collection').length > 0){
     $(window).on("scroll", function(e) {
        var s_scroll = $('.section-collection').offset().top - $(window).scrollTop();
         if(s_scroll < 101){
           $('body.collection').addClass('scroll-down')
         }else{
           $('body.collection').removeClass('scroll-down')
         }
      });

      var lastScrollTop = 0;
      $(window).scroll(function(event){
         var st = $(this).scrollTop();
         if (st < lastScrollTop){
          $('body.collection').removeClass('scroll-down')
         }
         lastScrollTop = st;
      });
      
    }

    if( $('.section-icon-with-text').length > 0){
      $(window).on("scroll", function(e) {
          var product_scroll = $('.snippet-addto-cart form').offset().top - $(window).scrollTop();
          var footer_scrol = $('#shopify-section-footer').offset().top - $(window).scrollTop() - $(window).outerHeight();
          if (product_scroll < 0) {
            $('.bottom-add-to-cart').addClass('active');
          }else{
            $('.bottom-add-to-cart').removeClass('active');
          }
          if (footer_scrol < 100) {
            $('.bottom-add-to-cart').removeClass('active');
          }
      });
    }

    $(document).on('click','.selectDropdown .option',function(){
        var id = $(this).attr('data-type');
        var cust_class = "."+id;
        $('.size-table .singal-size-table').hide();
        $(cust_class).show()
    });

    // $(document).on('click','.pro-page-wishlist',function(){
    //   $('.wishlist-notifiaction').addClass('active');
    //   setTimeout(() => {
    //     $('.wishlist-notifiaction.active').removeClass('active');
    //   }, "5000")
    // });


    $(document).on('click','.choose-selector .dup-add-to-cart',function(){
      $(this).hide();
      $('.choose-selector .select-size-add-to-cart').show();
    });

    var add_length = $('.address-list-outer .address-list').length;
    if (add_length == 0) {
      $('.empty-add-text').addClass('active')
    }else{
      $('.empty-add-text').removeClass('active')
    }

    $(document).on('click','.choose-cart .product-addcart',function(){
      $('#shopify-section-announcement-bar').removeClass('z-index-0');
      $('#shopify-section-header').removeClass('z-index-0');
    });


    if (window.location.href.includes('#recover')) {
      $('.main-login').hide();
      $('.recover-form').removeClass('hide-form')
    }

  if( $(".collection").length > 0){
    $(document).on('click','.menu-burdger',function(){
      $('.collection .header_announcement').addClass('active')
    });
  }

  
  if( $(".collection-mobile-bottom").length > 0){
    $(window).on("scroll", function(e) {
        var footer_scrol = $('#shopify-section-footer').offset().top - $(window).scrollTop() - $(window).outerHeight();
        if (footer_scrol < 1) {
          $('.collection-mobile-bottom').addClass('hide');
        }else{
          $('.collection-mobile-bottom').removeClass('hide');
        }
    });
  }

  // $(document).on('click','.apply-filter',function(){
  //   var count = $('.collection-grid').attr('data-count')
  //   setTimeout(() => { 
  //     console.log(count)
  //   }, 3000); 
  // });


  if( $(".clear-filter").length > 0){
    $(document).on('click','.clear-filter',function(){
        $('.product-count').html('');
    });
  }

  // mobile menu back button click

  $(document).on('click','.back_btn',function(){
    $('body').removeClass('hide-video');
    if ($(".level-2").hasClass("active")){
      $(".level-2").removeClass('active')
    }else{
      $(".level-1").removeClass('active')
    }
  })

  $(document).on('click','.nav-i-close',function(){
    console.log("nav-i-close-------------------");
      $('body').removeClass('hide-video');
     $('body').removeClass('open-menu');
    
       if ($(".level-2").hasClass("active")){
        $(".level-2").removeClass('active')
      }else{
        $(".level-1").removeClass('active')
      }
  });
  
  // mobile menu back button click


  // $(".navmobile-dropdown .level-2" ).each(function() {
  //   $(this).on("click", function(){
  //     $('body').addClass('hide-video');
  //     $('.mega-right-mobile ').hide();
  //   });
  // });

  // $(".main-back" ).each(function() {
  //   $(this).on("click", function(){
  //     $('body').removeClass('hide-video');
  //     $('.mega-right-mobile ').show();
  //   });
  // });

  // $('.navmobile-dropdown .level-2').on("click", function(){
  //     $('body').addClass('hide-video')
  // });
  // $('.main-back').on("click", function(){
  //   $('body').removeClass('hide')
  // });
  // $('.main-back').on("click", function(){
  //   $('.navmobile-dropdown li').removeClass('hide')
  // });
  // $(".main-back").each(function() {
  //   $(this).on("click", function(){
  //     $('body').removeClass('hide');
  //   });
  // });

  $(window).on("scroll", function(e) {
      var footer = $('#shopify-section-footer').offset().top - $(window).scrollTop() - $(window).outerHeight();
      if (footer < -285) {
        $('body').addClass('footer_fixed');
      }else{
        $('body').removeClass('footer_fixed');
      }
  });

  if( $(".facet-list input").length > 0){
    $('.facet-list input').on('change', function(){
      var checked = $('.facet-list input:checked').length;
      // Check if price range is active
      if ($(".filter-box .range-wrap .amount-wrap .amount-left").hasClass("active") || 
          $(".filter-box .range-wrap .amount-wrap .amount-right").hasClass("active")) {
        checked = checked + 1;
      }
      if (checked > 0) {
          $('.filter-top-inner .btn').addClass('active');
      }else{
          $('.filter-top-inner .btn').removeClass('active');
      }
    });
  }

  var len = $('.prev_viewed .swiper-slide').length;
  if (len == 0) {
    $('.prev_viewed').addClass('d-none')
  }else{
    $('.prev_viewed').removeClass('d-none')
  }

  if ($(window).width() < 992) {
     $(document).on('click','.second-mobile-nav .ls-sw-languages',function(e){
      $('.menu-main-parent').animate({scrollTop: $('.menu-main-parent')[0].scrollHeight}, "slow");
    });     
  }
  

  
});

document.addEventListener('DOMContentLoaded', function() {
  const bannerTextContainer = document.querySelector('.collection-banner-text');
  const collectionDescription = document.querySelector('.collection-description');

  function adjustAlignment() {
    if(bannerTextContainer != null){
      if (collectionDescription && collectionDescription.offsetHeight > 30) {
        bannerTextContainer.classList.add('align-center');
      } else {
        bannerTextContainer.classList.remove('align-center');
      }
    }
  }
  adjustAlignment();

  const activeItem = document.querySelector('ul.list--inline li.active');
    
    if (activeItem) {
        // Scroll the active item into view
        activeItem.scrollIntoView({
            behavior: 'smooth', // Smooth scrolling
            inline: 'center',   // Center the active item
            block: 'nearest'    // Ensure it remains in the nearest vertical view
        });
    }

  
});






// $(document).ready(function() {

//     new Swiper('.search_recommended_inr', {
//         loop: true,
//         slidesPerView: 4,
//         spaceBetween: 10,
//       mousewheel: {
//         releaseOnEdges: true,
//       },
//       scrollbar: {
//         el: ".swiper-scrollbar",
//       }
//     });
// });




